import APILibrary, { ClassExtender, GenerateResource } from './APILibrary';
import {
  InterviewAttributes,
  InterviewBelongsTo,
  InterviewHasMany,
  InterviewHasOne,
  InterviewInterface,
  InterviewResource,
  InterviewResourceClass,
} from './Interview';

/**
 * Utility interfaces
 */
export interface EmployerInterviewResource extends InterviewResource {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<InterviewAttributes>({
    queryName: 'employers/interviews',
    className: 'EmployerInterview',
    AttributesClass: InterviewAttributes,
    BelongsToClasses: [
      {
        Klass: InterviewBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: InterviewHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: InterviewHasMany,
      },
    ],
  });

export class EmployerInterviewResource extends ClassExtender<InterviewInterface>(
  BaseClass,
  InterviewResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerInterview =
  APILibrary.createResource<EmployerInterviewResource>(EmployerInterviewResource);
